import { CircleCheck, CircleDashed, MoveRight, OctagonX, TrendingUp } from 'lucide-preact'
import { SENDING_DOMAIN_PILL_LABELS, sendingDomainPill, type SendingDomainPill } from '@/types/sendingDomains'

// The domain-state colours and icons the ORB-953 mockups give every legacy screen: amber while it needs
// attention (setting up, holding), blue while warming, green once Ready, red when stopped.
const PILL_STYLES: Record<SendingDomainPill, { className: string; Icon: typeof TrendingUp }> = {
  SettingUp: { className: 'bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-300', Icon: CircleDashed },
  Warming: { className: 'bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-300', Icon: TrendingUp },
  Holding: { className: 'bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-300', Icon: MoveRight },
  Ready: { className: 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-300', Icon: CircleCheck },
  Stopped: { className: 'bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-300', Icon: OctagonX },
}

/** A sending domain's warm-up state as a pill; nothing for a state this build does not know (logged). */
export function SendingDomainStatePill({ domain }: { domain: { State: string; WarmupHoldReason?: string | null } }) {
  const pill = sendingDomainPill(domain)
  if (!pill) return null
  const { className, Icon } = PILL_STYLES[pill]
  return (
    <span className={`inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-xs font-medium ${className}`}>
      <Icon className="h-3 w-3 shrink-0" aria-hidden="true" />
      {SENDING_DOMAIN_PILL_LABELS[pill]}
    </span>
  )
}
